import { useMemo } from 'react'

import { getAdjustments, getFormElements, useConfig } from './configuration'

export const useAdjustments = () => {
  const adjustments = useConfig(getAdjustments)

  return useMemo(
    () => ({
      getAdjustment: (name: string) => {
        const adjustment = adjustments[name]

        if (!adjustment) {
          throw new Error(`Adjustment ${name} not found`)
        }

        return adjustment
      },

      adjustments,
    }),
    [adjustments],
  )
}

export const useFormElements = (names: string[] = []) => {
  const formElements = useConfig(getFormElements)

  return useMemo(
    () =>
      names.map((name) => {
        const formElement = formElements[name]

        if (!formElement) {
          throw new Error(`Form element ${name} not found`)
        }

        return formElement
      }),
    names,
  )
}
